<svg
  version="1.1"
  id="svg2"
  xml:space="preserve"
  width="100%"
  height="100%"
  viewBox="0 0 281.74667 152.86667"
>
  <style>
    .number {
      font-family: Avenir, sans-serif;
      font-style: normal;
      font-weight: 500;
      color: #000000;
    }
  </style>
  <defs id="defs6" />
  <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,152.86667)">
    <g id="g12" transform="scale(0.1)">
      <path
        d="M 0,1146.47 H 2113.14 V 0 H 0 v 1146.47"
        style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none;"
        id="path14"
      />
      <g id="g16" transform="scale(10)">
        <text
          transform="matrix(1,0,0,-0.99871166,53.1996,84.7105)"
          style="
            font-variant: normal;
            font-weight: bold;
            font-size: 12.0155px;
            font-family: Helvetica;
            -inkscape-font-specification: Helvetica-Bold;
            writing-mode: lr-tb;
            fill: #142c61;
            fill-opacity: 1;
            fill-rule: nonzero;
            stroke: none;
          "
          id="text22"
        >
          <tspan
            x="0 8.6751766 12.01548 15.355783 18.692156 25.372763 30.046785 33.387089 42.062263 49.403725 56.745182 63.427792"
            y="0"
            id="tspan18"
          >
            Biller Code:
            <tspan class="number">{{ billerCode }}</tspan>
          </tspan>
          <tspan x="0 8.6751766 15.355783 19.360905" y="15.10466" id="tspan20">Ref:
            <tspan class="number">{{ refNumber }}</tspan>
          </tspan>
        </text>
      </g>
      <path
        d="m 427.246,562.664 c 0,-9.723 -7.891,-17.633 -17.637,-17.633 H 81.7109 c -9.6992,0 -17.5937,7.91 -17.5937,17.633 v 498.776 c 0,9.7 7.8945,17.6 17.5937,17.6 H 409.609 c 9.746,0 17.637,-7.9 17.637,-17.6 V 562.664"
        style="fill: #142c61; fill-opacity: 1; fill-rule: nonzero; stroke: none;"
        id="path24"
      />
      <path
        d="m 406.348,574.895 c 0,-4.532 -2.285,-8.829 -8.907,-8.946 H 93.4414 c -0.1797,0 -0.3867,0 -0.6055,0.039 -4.3359,0.254 -7.8007,3.828 -7.8007,8.223 0,0 0.0273,233.613 0.0273,373.387 H 177.691 L 140.387,933.992 V 729.453 c 0,-5.73 3.172,-8.73 8.027,-9.172 h 125.785 c 42.989,1.391 77.383,36.567 77.383,79.867 0,28.399 -14.805,53.301 -37.051,67.481 13.907,12.332 24.422,32.5 24.422,52.363 0,52.918 -37.539,82.948 -91.183,82.948 h -52.149 v 55.2 c 88.449,0 201.82,-0.04 201.82,-0.04 6.875,0 8.907,-4.49 8.907,-8.93 z M 85.0625,1049.82 v 0.02 c 0,4.41 3.4102,7.95 7.6719,8.3 0,0 19.0466,0 47.6526,0 v -55.23 H 85.0625 c 0,28.93 0,46.91 0,46.91 z M 194.801,949.102 h 60.023 c 15.781,0 28.496,-13.497 28.496,-29.18 0,-15.742 -12.715,-28.496 -28.496,-28.496 l -10.375,-0.547 c -5.57,-0.223 -8.469,-3.496 -8.66,-8.613 v -35.008 c 0.399,-5.567 3.797,-8.469 9.129,-8.469 h 25.785 c 17.117,0 30.977,-13.887 30.977,-30.937 0,-16.161 -12.492,-29.364 -28.242,-30.696 l -69.848,-0.054 c -5.192,0.136 -8.586,3.132 -8.789,8.828 z M 413.887,1083.31 H 77.4453 c -9.6953,0 -17.5937,-7.89 -17.5937,-17.61 V 558.406 c 0,-9.746 7.8984,-17.633 17.5937,-17.633 H 413.887 c 9.726,0 17.617,7.887 17.617,17.633 V 1065.7 c 0,9.72 -7.891,17.61 -17.617,17.61 z m -185.864,-448.279 14.887,42.168 15.781,-42.168 z m 26.25,53.211 c -1.128,2.293 -1.937,3.789 -6.011,3.789 h -10.699 c -4.071,0 -4.883,-1.496 -6.008,-3.789 -1.032,-2.265 -30.973,-83.371 -30.973,-83.371 0,0 -1.766,-3.492 2.746,-3.492 4.602,0 5.602,-0.059 7.555,-0.059 2.062,0 4.437,0.391 5.558,3.614 0.977,2.832 5.457,15.254 5.457,15.254 h 42.028 c 0,0 4.48,-12.422 5.461,-15.254 1.121,-3.223 3.496,-3.614 5.554,-3.614 1.954,0 2.95,0.059 7.559,0.059 4.512,0 2.742,3.492 2.742,3.492 0,0 -29.937,81.106 -30.969,83.371 z M 176.41,648.488 h -21.168 v 28.692 l 21.168,0.019 c 7.93,0 14.36,-6.426 14.36,-14.367 0,-7.922 -6.43,-14.344 -14.36,-14.344 z m 0.25,43.551 h -33 c -2.863,0 -3.273,-2.359 -3.273,-3.824 0,-1.485 0.011,-83.535 0.011,-83.535 0,-3.457 3.161,-3.301 3.512,-3.301 h 8.438 c 1.382,0 2.91,1.113 2.91,2.703 l -0.016,29.941 h 21.418 c 16.02,0 29.016,13 29.016,29.012 0,16.02 -12.996,29.004 -29.016,29.004 z m 168.836,0.078 c -4.598,0 -6.656,0.063 -8.609,0.063 -2.063,0 -4.446,-0.383 -5.559,-3.614 l -4.121,-7.367 -16.453,-29.136 -16.477,29.136 -4.101,7.367 c -1.113,3.231 -3.496,3.614 -5.559,3.614 -1.961,0 -4.031,-0.063 -8.621,-0.063 -4.512,0 -2.754,-3.496 -2.754,-3.496 0,0 16.719,-29.629 30.156,-53.57 0,0 -0.214,-28.457 -0.214,-30.434 0,-1.988 1.054,-3.238 3.203,-3.238 h 7.851 c 1.407,0 3.926,0.113 3.926,3.144 l -0.078,30.528 c 13.445,23.941 30.156,53.57 30.156,53.57 0,0 1.77,3.496 -2.746,3.496"
        style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none;"
        id="path26"
      />
      <path
        d="M 2022.27,571.613 H 458.941 V 1052.42 H 2022.27 Z"
        style="
          fill: none;
          stroke: #142c61;
          stroke-width: 10;
          stroke-linecap: butt;
          stroke-linejoin: miter;
          stroke-miterlimit: 10;
          stroke-dasharray: none;
          stroke-opacity: 1;
        "
        id="path28"
      />
      <g id="g30" transform="scale(10)">
        <text
          transform="matrix(1,0,0,-1,8.89453,39.9531)"
          style="
            font-variant: normal;
            font-weight: bold;
            font-size: 10.5px;
            font-family: Helvetica;
            -inkscape-font-specification: Helvetica-Bold;
            writing-mode: lr-tb;
            fill: #142c61;
            fill-opacity: 1;
            fill-rule: nonzero;
            stroke: none;
          "
          id="text34"
        >
          <tspan
            x="0 5.7153306 11.738769 14.733399 20.77832 27.259281 33.693359 40.13916 46.634769 52.474606 55.391598 62.974606 65.891602 68.895988 75.310043 78.815903 84.849594 88.91893 95.414551 101.43212 104.92863 107.84562 115.46867 121.3632 127.79288 133.69815 136.59561 143.05751 149.47157 152.38858 158.22842 161.1454"
            y="0"
            id="tspan32"
          >
            Telephone &amp; Internet Banking – B
          </tspan>
        </text>
        <text
          transform="matrix(1,0,0,-1,177.71053,39.9531)"
          style="
            font-variant: normal;
            font-weight: bold;
            font-size: 8.925px;
            font-family: Helvetica;
            -inkscape-font-specification: Helvetica-Bold;
            writing-mode: lr-tb;
            fill: #142c61;
            fill-opacity: 1;
            fill-rule: nonzero;
            stroke: none;
          "
          id="text38"
        >
          <tspan x="0 5.5331993 11.358397" y="0" id="tspan36">PAY</tspan>
        </text>
        <text
          transform="matrix(1,0,0,-1,194.62653,42.92576)"
          style="
            font-variant: normal;
            font-weight: bold;
            font-size: 5.20328px;
            font-family: Helvetica;
            -inkscape-font-specification: Helvetica-Bold;
            writing-mode: lr-tb;
            fill: #142c61;
            fill-opacity: 1;
            fill-rule: nonzero;
            stroke: none;
          "
          id="text42"
        >
          <tspan x="0" y="0" id="tspan40">®</tspan>
        </text>
        <text
          transform="matrix(0.969998,0,0,-1,8.89453,29.4531)"
          style="
            font-variant: normal;
            font-weight: normal;
            font-size: 8.04125px;
            font-family: Helvetica;
            -inkscape-font-specification: Helvetica;
            writing-mode: lr-tb;
            fill: #142c61;
            fill-opacity: 1;
            fill-rule: nonzero;
            stroke: none;
          "
          id="text50"
        >
          <tspan
            x="0 5.8057823 10.276717 14.747652 16.98312 21.454056 25.47468 27.710148 29.945616 33.96624 38.437176 42.908112 45.585846 47.821312 52.292248 56.763184 61.234119 65.254745 67.490211 71.961143 74.638885 76.874352 79.109818 80.894974 85.365913 89.836845 94.307777 98.328407 100.12137 104.59342 106.37942 108.61344 110.40045 114.87251 118.89313 121.12714 122.91415 125.14816 129.62022 131.85423 133.64024 138.11229 142.58435 144.81837 147.05238 151.52444 153.75845 160.45682 164.92886 168.94949 173.42155"
            y="0"
            id="tspan44"
          >
            Contact your bank or financial institution to make
          </tspan>
          <tspan
            x="0 2.2354674 6.7064023 8.49156 12.512185 14.747652 19.218588 23.689522 27.710148 34.408508 38.879444 43.35038 45.585846 47.821312 50.056782 52.734516 57.205452 63.903812 66.139282 70.159904 74.630844 79.101776 81.77951 84.014977 88.035606 92.506538 96.977478 101.44841 105.91934 110.39028 112.62575 114.86121 118.88509 123.35714 127.37777 129.16377 133.63582 138.10788 142.12851 144.3625 146.59653 151.06859 155.54063 160.0127 161.79869 164.03271 168.50075 172.97279 175.65054"
            y="10.5"
            id="tspan46"
          >
            this payment from your cheque, savings, debit or
          </tspan>
          <tspan
            x="0 2.2354674 4.9132037 9.3841391 13.855074 17.875698 22.346634 26.367258 28.602726 30.387884 34.858818 39.329754 41.56522 46.036156 50.056782 54.077408 58.54834 63.019276 67.490211 69.725677 71.961143 74.196617 80.894974 85.365913 88.043648 92.51458 94.750046 96.53521 101.00614 103.24161 107.71255 109.94801 112.18348 117.98926 123.79504 129.60083 131.83629 136.30724 140.77817 145.2491 149.27899 151.513 155.53363 160.00569 166.70404 168.93806 173.41011"
            y="21"
            id="tspan48"
          >
            transaction account. More info: www.bpay.com.au
          </tspan>
        </text>
      </g>
      <path
        d="M 2113.14,1146.47 H 0 V 0 h 2113.14 v 1146.47 z m -12,-12 V 12 H 12.0039 V 1134.47 H 2101.14"
        style="fill: #142c61; fill-opacity: 1; fill-rule: nonzero; stroke: none;"
        id="path52"
      />
    </g>
  </g>
</svg>
